import React, { useEffect, useState } from 'react'
import {
  FormDashboardLabel as Label,
  Checkbox,
  RequiredLabel,
} from '../../../components'
import { useDispatch, useSelector } from 'react-redux'
import debounce from 'lodash.debounce'
import { updateForm } from '../../../features/resource-form/slice'
import DevLogger from '../../../components/_dev-logger'
import { useInternationalization } from '../../../features/i18n'

const SidebarCategories = () => {
  const dispatch = useDispatch()
  const {translate, language} = useInternationalization()
  const categories = useSelector(state => state.system.categories_resource)
  const [categoryOptions, setCategoryOptions] = useState([])
  const form = useSelector(state => state.resourceForm.data)
  const [defaultChecked, setDefaultChecked] = useState([])

  useEffect(() => {
    if(form.categories && form.categories.length > 0){
      setDefaultChecked(form.categories)
    }
    //eslint-disable-next-line
  }, [form])

  useEffect(() => {
    if(categories && categories.length > 0){
      let options = categories.map(c => {
        return {
          id: c.id,
          title: c.name[language.name]
        }
      })
      setCategoryOptions(options)
    }
  }, [categories, setCategoryOptions, language])

  const handleInput = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateForm({key, value}))
    }
  }, 250)

  const onCategoryCheckboxChange = (e) => {
    const lastCategories = form.categories ? [...form.categories] : []

    if (e.target.checked) {
      handleInput({
        target: {
          name: 'categories',
          value: [
            ...lastCategories,
            parseInt(e.target.value)
          ]
        }
      })
    } else {
      handleInput({
        target: {
          name: 'categories',
          value: lastCategories.filter(v => v !== parseInt(e.target.value))
        }
      })
    }
  }

  return (
    <>
      <Label>{translate('SEARCH', 'categories')} <RequiredLabel /></Label>

      <div className="pt-3">
        <DevLogger data={defaultChecked}/>
        <div className="grid grid-cols-2 gap-1 lg:grid-cols-1">
          {categoryOptions.map((cat) => (
            <div key={cat.id}>
              <Checkbox
                className="mb-2"
                label={cat.title}
                value={cat.id}
                checked={defaultChecked && defaultChecked.includes(cat.id)}
                onChange={onCategoryCheckboxChange}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default SidebarCategories
